import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    setSnackBar
  } from "../../store/common/commonSlice";
import { forgot_password_request, reset_password, setResetState, setShowPassword } from "../../store/user/userSlice";

const mapStateToProps = (state) => {
  const {forgot_password_is_loading,show_password,company_details} = state.user;
  return {
    forgot_password_is_loading : forgot_password_is_loading,
    show_password : show_password,
    company_details : company_details
  }
};

const mapDispatchToProps = (dispatch) => 
    bindActionCreators(
        {
          forgot_password_request,
          setShowPassword,
          setSnackBar,
          reset_password,
          setResetState
        },
        dispatch
    );

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;